<button class="feedback-container"
   [attr.aria-label]="minimizedHeaderAriaLabel"
   (click)="openFeedback()"
   data-clicklog="custom"
   id="feedbackContainer"
   #feedbackContainer
   (ohpResize)="updatePageOffset()"
   [title]="minimizedHeaderAriaLabel">
    <div class="feedback-header">
        <ohp-icon-font aria-hidden="true" iconFontName="Chat" size="14" cssClass="feedback-container__header-icon"></ohp-icon-font>
        <span>{{ header }}</span>
    </div>
</button>
